<template>
  <div class="bg-white">
    <i18n path="ec-line002.content.purchaseType">
      <b>{{ text }}</b>
    </i18n>

    <div class="w-full overflow-auto flex flex-nowrap mt-1 p-2 justify-start">
      <div
        v-for="item in items"
        :key="item.id"
        class="ec-line002__sale-type__item"
        :class="{ selected: value === item.id }"
        @click="onSelect(item.id)"
      >
        {{ item.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
    },
  },
  data() {
    return {
      items: [
        { id: this.Constants.SALE_TYPE.SUBSCRIPTION, text: this.$t('ec-line002.content.subscription') },
        {
          id: this.Constants.SALE_TYPE.NORMAL,
          text: this.$t('ec-line002.content.normal'),
        },
      ],
    }
  },
  computed: {
    text() {
      return this.items.find((i) => i.id === this.value)?.text
    },
  },
  methods: {
    onSelect(id) {
      this.$emit('input', id)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/ec-line002/sale-type.scss';
</style>
